{{#if this.stepMessage}}
  <div class="step-message {{this.stepMessage.state}}">
    <div class="text">
      {{this.stepMessage.text}}
    </div>
    {{#if this.showReset}}
      <a role="button" class="reset-wizard" {{action "resetWizard"}}>
        {{i18n "wizard.reset"}}
      </a>
    {{/if}}
  </div>
{{/if}}
{{#if this.step.permitted}}
  {{custom-wizard-step
    step=this.step
    wizard=this.wizard
    goNext=(action "goNext")
    goBack=(action "goBack")
    showMessage=(action "showMessage")
  }}
{{/if}}